export const NIGERIAN_STATES = [
  'Abia', 'Adamawa', 'Akwa Ibom', 'Anambra', 'Bauchi', 'Bayelsa', 'Benue', 'Borno', 
  'Cross River', 'Delta', 'Ebonyi', 'Edo', 'Ekiti', 'Enugu', 'FCT - Abuja', 'Gombe', 
  'Imo', 'Jigawa', 'Kaduna', 'Kano', 'Katsina', 'Kebbi', 'Kogi', 'Kwara', 'Lagos', 
  'Nasarawa', 'Niger', 'Ogun', 'Ondo', 'Osun', 'Oyo', 'Plateau', 'Rivers', 'Sokoto', 
  'Taraba', 'Yobe', 'Zamfara'
];

export const LGAS_BY_STATE: Record<string, string[]> = {
  'Abia': ['Umuahia North', 'Umuahia South', 'Aba North', 'Aba South', 'Ohafia'],
  'Adamawa': ['Yola North', 'Yola South', 'Mubi North', 'Mubi South', 'Jimeta'],
  'Akwa Ibom': ['Uyo', 'Eket', 'Ikot Ekpene', 'Oron', 'Ibeno'],
  'Anambra': ['Awka South', 'Awka North', 'Onitsha North', 'Onitsha South', 'Nnewi North'],
  'Bauchi': ['Bauchi', 'Azare', 'Misau', 'Katagum', 'Jama\'are'],
  'Bayelsa': ['Yenagoa', 'Sagbama', 'Ogbia', 'Southern Ijaw', 'Ekeremor'],
  'Benue': ['Makurdi', 'Gboko', 'Otukpo', 'Katsina-Ala', 'Vandeikya'],
  'Borno': ['Maiduguri', 'Jere', 'Biu', 'Gwoza', 'Ngala'],
  'Cross River': ['Calabar Municipal', 'Calabar South', 'Ikom', 'Ogoja', 'Obudu'],
  'Delta': ['Asaba', 'Warri South', 'Warri North', 'Sapele', 'Ughelli'],
  'Ebonyi': ['Abakaliki', 'Afikpo North', 'Afikpo South', 'Onueke', 'Ishielu'],
  'Edo': ['Oredo', 'Ikpoba-Okha', 'Egor', 'Ovia North-East', 'Esan Central'],
  'Ekiti': ['Ado Ekiti', 'Ikere', 'Oye', 'Ikole', 'Ijero'],
  'Enugu': ['Enugu North', 'Enugu South', 'Enugu East', 'Nsukka', 'Udi'],
  'FCT - Abuja': ['Garki', 'Wuse', 'Asokoro', 'Maitama', 'Gwarinpa', 'Kubwa', 'Lugbe', 'Kuje', 'Bwari', 'Abaji'],
  'Gombe': ['Gombe', 'Kaltungo', 'Dukku', 'Billiri', 'Nafada'],
  'Imo': ['Owerri Municipal', 'Owerri North', 'Owerri West', 'Orlu', 'Okigwe'],
  'Jigawa': ['Dutse', 'Hadejia', 'Kazaure', 'Gumel', 'Birnin Kudu'],
  'Kaduna': ['Kaduna North', 'Kaduna South', 'Zaria', 'Sabon Gari', 'Kafanchan'],
  'Kano': ['Kano Municipal', 'Dala', 'Fagge', 'Gwale', 'Tarauni', 'Nassarawa'],
  'Katsina': ['Katsina', 'Funtua', 'Daura', 'Malumfashi', 'Dutsin-Ma'],
  'Kebbi': ['Birnin Kebbi', 'Argungu', 'Yauri', 'Zuru', 'Jega'],
  'Kogi': ['Lokoja', 'Okene', 'Idah', 'Anyigba', 'Kabba'],
  'Kwara': ['Ilorin West', 'Ilorin East', 'Ilorin South', 'Offa', 'Omu-Aran'],
  'Lagos': ['Ikeja', 'Lekki', 'Victoria Island', 'Epe', 'Badagry', 'Ikorodu', 'Surulere', 'Oshodi-Isolo', 'Alimosho', 'Lagos Island'],
  'Nasarawa': ['Lafia', 'Keffi', 'Akwanga', 'Karu', 'Nasarawa'],
  'Niger': ['Minna', 'Bida', 'Suleja', 'Kontagora', 'Lapai'],
  'Ogun': ['Abeokuta North', 'Abeokuta South', 'Ijebu Ode', 'Sagamu', 'Ota'],
  'Ondo': ['Akure South', 'Akure North', 'Ondo Town', 'Owo', 'Ore'],
  'Osun': ['Osogbo', 'Ife Central', 'Ilesa East', 'Ede North', 'Iwo'],
  'Oyo': ['Ibadan North', 'Ibadan North-East', 'Ibadan North-West', 'Ibadan South-East', 'Ibadan South-West'],
  'Plateau': ['Jos North', 'Jos South', 'Bukuru', 'Pankshin', 'Shendam'],
  'Rivers': ['Port Harcourt', 'Obio-Akpor', 'Eleme', 'Ikwerre', 'Oyigbo', 'Ogoni'],
  'Sokoto': ['Sokoto North', 'Sokoto South', 'Wamako', 'Dange Shuni', 'Bodinga'],
  'Taraba': ['Jalingo', 'Wukari', 'Bali', 'Gashaka', 'Takum'],
  'Yobe': ['Damaturu', 'Gashua', 'Nguru', 'Potiskum', 'Geidam'],
  'Zamfara': ['Gusau', 'Kaura Namoda', 'Talata Mafara', 'Tsafe', 'Anka']
};
